import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Paper, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(8, 4),
		textAlign: 'center',
		background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
		color: 'white',
		minHeight: 500,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	},
	ctaButton: {
		marginTop: theme.spacing(4),
		padding: theme.spacing(1.5, 4),
		fontSize: '1.1rem'
	}
}));

function WelcomeHero({ config = {}, branding = {} }) {
	const classes = useStyles();

	const {
		title = 'Welcome to Heidi Platform',
		subtitle = 'Your gateway to high-performance computing and applications',
		ctaText = 'Get Started'
	} = config;

	const { welcomeMessage } = branding;

	return (
		<Paper className={classes.root} elevation={0}>
			<Typography variant="h2" gutterBottom>
				{welcomeMessage || title}
			</Typography>
			<Typography variant="h5" paragraph style={{ maxWidth: 600 }}>
				{subtitle}
			</Typography>
			<Button
				variant="contained"
				color="secondary"
				size="large"
				className={classes.ctaButton}
				component={Link}
				to="/heidi-apps"
			>
				{ctaText}
			</Button>
		</Paper>
	);
}

export default WelcomeHero;
